import { Injectable, OnDestroy } from '@angular/core';
import {ChatSettingBase} from "@core/base/chat-setting-base";
import {ChatBase} from "@core/base/chat-base";
import {ChatActionBase} from "@core/base/chat-action-base";
import { SessionBase } from "@core/base/session-base";
import { SubscriptionBase } from "@core/base/subscription-base";
import { ChatUtilsService } from "@core/shared/chat-utils.service";
import { OfficeBase } from "@core/base/office-base";
import { ICoreEnv } from "@core/core-env/core-env.types";

interface ICoreModules {
    chatSetting: ChatSettingBase,
    chat: ChatBase,
    chatAction: ChatActionBase,
    chatUtils: ChatUtilsService,
    session: SessionBase,
    subscription: SubscriptionBase,
    office: OfficeBase,
}

@Injectable({
    providedIn: 'root'
})
export class Core implements OnDestroy {
    public chatSetting!: ChatSettingBase
    public chat!: ChatBase
    public chatAction!: ChatActionBase
    public session!: SessionBase
    public subscription!: SubscriptionBase
    public chatUtils!: ChatUtilsService
    public office!: OfficeBase
    public env!: ICoreEnv

    constructor() {}

    public defineModules(modules: ICoreModules, env: ICoreEnv): void {
        this.env = env
        this.chatSetting = modules.chatSetting;
        this.chat = modules.chat;
        this.chatAction = modules.chatAction;
        this.session = modules.session;
        this.subscription = modules.subscription;
        this.chatUtils = modules.chatUtils;
        this.office = modules.office
    }

    public ngOnDestroy(): void {
        const chat = this.chat;
        const chatSetting = this.chatSetting;
        if (chat) {
            chat.onDestroy();
        }

        if (chatSetting) {
            chatSetting.onDestroy();
        }
    }
}
